var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "min-height": "350px"
    }
  }, [_vm._m(0), !_vm.loading ? [_c('BreakdownChart', {
    attrs: {
      "series": _vm.series,
      "element": "chart-breakdown-plan-emergency"
    }
  })] : _c('div', {
    staticClass: "d-flex w-100 justify-content-center my-5"
  }, [_c('b-spinner', {
    staticStyle: {
      "height": "74px",
      "width": "74px"
    }
  })], 1)], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-3"
  }, [_c('h5', {
    staticClass: "text-primary"
  }, [_c('strong', [_vm._v("MAINTENANCE BREAKDOWN")])])]);

}]

export { render, staticRenderFns }